import React from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography
} from '@mui/material';
import { BlockOutlined } from '@mui/icons-material';
import { useMsal } from '@azure/msal-react';
import AuthShell from '../components/AuthShell';
import OpenCareBrand from '../components/OpenCareBrand';
import { getDisplayCustomerName } from '../lib/customerDisplay';
import { openAccessRequestMail } from '../lib/accessRequestMail';
import {
  clearSelectedCustomerId,
  getPortalSelectUrl
} from '../lib/selectedCustomer';
import { navigateTo } from '../lib/runtimeUrls';

const AccessDeniedPage = () => {
  const { accounts } = useMsal();
  const customerName = getDisplayCustomerName();
  const account = accounts[0];

  const handleChangeCustomer = () => {
    clearSelectedCustomerId();
    navigateTo(getPortalSelectUrl());
  };

  const handleRequestAccess = () => {
    openAccessRequestMail({
      customerName,
      requesterName: account?.name || '',
      requesterEmail: account?.username || ''
    });
  };

  return (
    <AuthShell>
      <Card
        elevation={0}
        sx={{
          borderRadius: 3,
          border: '1px solid var(--oc-border)',
          boxShadow: '0 30px 60px -20px rgba(14, 40, 65, 0.35)'
        }}
      >
        <CardContent sx={{ p: 4, textAlign: 'center' }}>
          <OpenCareBrand gutterBottom />
          <BlockOutlined
            sx={{ fontSize: 48, color: 'error.main', my: 2 }}
          />
          <Typography variant="h6" fontWeight={700} gutterBottom>
            Ingen tilgang
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            Du har ikke tilgang til {customerName}. Velg en annen kommune eller be
            om tilgang.
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={handleChangeCustomer}
            >
              Bytt kommune
            </Button>
            <Button
              fullWidth
              variant="outlined"
              color="primary"
              onClick={handleRequestAccess}
            >
              Be om tilgang
            </Button>
          </Box>
        </CardContent>
      </Card>
    </AuthShell>
  );
};

export default AccessDeniedPage;
